import moment from 'moment'
export function disabledDate(current) {
  return current && current < moment().subtract(1, 'days').endOf('day')
}
let range = (start: any, end: any) => {
  const result: number[] = []
  for (let i = start; i < end; i++) {
    result.push(i)
  }
  return result
}
export let disabledDateTime: any = (current: any) => {
  if (current) {
    let today = moment().date()
    if (today == current.date()) {
      let minute = Number(moment().minutes())
      let hour = Number(moment().hour())
      let finalHour: number, finalMinute: number
      if (current.hour() > hour) {
        finalMinute = 0
      } else if (current.minute() >= 58) {
        finalHour = hour + 1
        finalMinute = 0
      } else {
        finalHour = hour
        finalMinute = minute + 1
      }
      return {
        disabledHours: () => range(0, finalHour),
        disabledMinutes: () => range(0, finalMinute),
      }
    }
    if (moment() > current) {
      return {
        disabledHours: () => range(0, 24),
        disabledMinutes: () => range(0, 60),
        disabledSeconds: () => range(0, 60),
      }
    }
  } else {
    return {
      disabledHours: () => range(0, 24),
      disabledMinutes: () => range(0, 60),
      disabledSeconds: () => range(0, 60),
    }
  }
}

export const monthList = () =>
  Array.from({ length: 31 }, (_, i) => ({
    title: `${i + 1}日`,
    value: i + 1,
  }))

export const weekList = [
  { title: '周一', value: 1 },
  { title: '周二', value: 2 },
  { title: '周三', value: 3 },
  { title: '周四', value: 4 },
  { title: '周五', value: 5 },
  { title: '周六', value: 6 },
  { title: '周日', value: 0 },
]
